import { TextInputField } from "@sainsburys-tech/luna-form";
import { Form } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import {
  FIELDS,
  FormInputLevels
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import FamilyGroupAutoComplete from "../../SharedComponents/FamilyGroupAutoComplete";
import { useSelector } from "react-redux";
import { UI_CONSTANTS } from "../../../Constants/constants";
import { ProductValueType } from "../../../Types/Product/ProductValueType";
import { ProductError } from "../../../Types/Product/ProductError";

const MeasurementsClothingForm: FC<ProductFormProps> = (props) => {
  const values = props.values as ProductValueType;
  const errors: ProductError | null | undefined = props.errors && props.errors as ProductError;
  
  const [isFormDirty, setIsFormDirty] = useState<boolean | undefined>(
    props.dirty || true
  );
  const pageDirtyPayload = useSelector((state: any) => state.pageDirtyReducer);

  useEffect(() => {
    if (pageDirtyPayload.data !== null) {
      let compareResult =
        JSON.stringify(pageDirtyPayload.data.values) ===
        JSON.stringify(values);
      setIsFormDirty(compareResult);
    }
  }, [pageDirtyPayload]);

  const packSizeToDisplay = () => {
    if (values.alias === UI_CONSTANTS.SAINSBURYS_SKU || values.alias === UI_CONSTANTS.SAINSBURYS_PACK) {
      return `CS${values.packSize}`;
    }

    if (values.alias === UI_CONSTANTS.ARGOS) {
      return `EA`;
    }

    return values.packSize;
  };

  return (
    <Container>
      <Form className="o-form">
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.sainId.name}
              label={FormInputLevels.SainId}
              maxLength={128}
              value={values.sainId}
              error={errors?.sainId}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name="displayItemNumber"
              label={FormInputLevels.DisplayItemNumber}
              value={
                values.skuNumber
                  ? values.skuNumber
                  : values.catNumber
              }
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <FamilyGroupAutoComplete
              productType={values.productType}
              className="hide-arrow"
              label="Family Group"
              name="FamilyGroupNew"
              placeholder="Please select"
              testid="autocomplete-field"
              initialValue={values.familyGroup || ""}
              onSelect={(e: any) => {
                if (e === null || e?.value === null) {
                  e = {
                    label: values.familyGroup,
                    value: { desc: values.familyGroup },
                  };
                }
                props.onChange(e, e.label, e.value?.desc, false);
              }}
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.productType.name}
              label={FormInputLevels.ProductType}
              value={values.productType}
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.packSize.name}
              label={FormInputLevels.PackSize}
              value={packSizeToDisplay()}
              disabled={true}
            />
          </GridItem>
        </GridWrapper>

        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.ti.name}
              label={FormInputLevels.InnerTi}
              maxLength={128}
              value={values.ti}
              error={errors?.ti}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.hi.name}
              label={FormInputLevels.InnerHi}
              maxLength={128}
              value={values.hi}
              error={errors?.hi}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.breakPack.name}
              label={FormInputLevels.BreakPack}
              maxLength={128}
              value={values.breakPack}
              error={errors?.breakPack}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.innerHeight.name}
              label={FormInputLevels.InnerHeight}
              maxLength={128}
              value={values.innerHeight}
              error={errors?.innerHeight}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.innerLength.name}
              label={FormInputLevels.InnerLength}
              maxLength={128}
              value={values.innerLength}
              error={errors?.innerLength}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.innerWeight.name}
              label={FormInputLevels.InnerWeight}
              maxLength={128}
              value={values.innerWeight}
              error={errors?.innerWeight}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.innerWidth.name}
              label={FormInputLevels.InnerWidth}
              maxLength={128}
              value={values.innerWidth}
              error={errors?.innerWidth}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.innerNetWeight.name}
              label={FormInputLevels.InnerNetWeight}
              maxLength={128}
              value={values.innerNetWeight}
              error={errors?.innerNetWeight}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.outerLength.name}
              label={FormInputLevels.OuterLength}
              maxLength={128}
              value={values.outerLength}
              error={errors?.outerLength}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.outerHeight.name}
              label={FormInputLevels.OuterHeight}
              maxLength={128}
              value={values.outerHeight}
              error={errors?.outerHeight}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.outerWeight.name}
              label={FormInputLevels.OuterWeight}
              maxLength={128}
              value={values.outerWeight}
              error={errors?.outerWeight}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.outerLength.name}
              label={FormInputLevels.OuterWidth}
              maxLength={128}
              value={values.outerWidth}
              error={errors?.outerWidth}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
        </GridWrapper>

        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.outerNetWeight.name}
              label={FormInputLevels.OuterNetWeight}
              maxLength={128}
              value={values.outerNetWeight}
              error={errors?.outerNetWeight}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.grabInBox.name}
              label={FormInputLevels.GrabInBox}
              maxLength={128}
              value={values.grabInBox}
              error={errors?.grabInBox}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
            />
          </GridItem>
        </GridWrapper>
      </Form>
      <ActionButton
        onSubmit={props.onSubmit}
        onClearAll={props.onClearAll}
        onCancel={props.onCancel}
        isAddDisabled={isFormDirty}
        isDirty={props.dirty}
        isEdit={props.isEdit}
        isClearButtonRequired={false}
        submitted={props.submitted}
      />
    </Container>
  );
};

export default MeasurementsClothingForm;
